
import ArticlesList from "../components/articles/article-list";
import InsideIndustry from "../components/leadership/inside-industry";
import KeyProgram from "../components/leadership/key-programs";
import FounderResource from "../components/portfolio/founder-resources";
import Banner from "../components/ui-components/banner";
import HomePortfolio from "../components/ui-components/portfolio";
import { fetchLeadershipPage } from "../services/api";
// import SeoHead from '../components/SeoHead.jsx';
const LeadershipPage=({lang})=>{

    return(
        <>
         {/* <SeoHead slug="industry" lang={lang} /> */}
        <Banner  fetchData={fetchLeadershipPage} lang={lang} />
                <KeyProgram lang={lang}/>
                <InsideIndustry lang={lang}/>
        {/* <ArticlesList lang={lang} variant="white"/> */}

        </>
    )
}

export default LeadershipPage;